import { SaleType } from '@models/Products';

import { Dispatch, SetStateAction } from 'react';

export interface KpiTypesOption {
  label: KpiOptionForLabel;
  value: KpiOptionForValue;
}

export enum FocusArea {
  market = 'market',
  retailer = 'retailer',
}

export enum KpiOptionForLabel {
  bestSellers = 'Best Sellers',
  highestGrowth = 'Highest Growth',
}

export enum KpiOptionForValue {
  bestSellers = 'bestSellers',
  highestGrowth = 'highestGrowth',
}

export interface Props {
  selectedKpi: KpiTypesOption;
  selectedFocusArea: FocusArea;
  selectedSaleType: SaleType;
  setSelectedKpi: Dispatch<SetStateAction<KpiTypesOption>>;
  setSelectedFocusArea: Dispatch<SetStateAction<FocusArea>>;
  setSelectedSaleType: Dispatch<SetStateAction<SaleType>>;
  isLoading: boolean;
}

export interface RadioInfo {
  name: string;
  value: string;
  selectedState: FocusArea | SaleType;
  onChange: (value: string) => void;
}
